export const sourceCategoryTitles = {
  inbound: 'Inbound',
  outbound: 'Outbound',
  internal: 'Internal',
  unknown: 'Other',
  referrals: 'Referral',
  other: 'Other',
};
